/**
 * ListaCards — lista do /acompanhamento abaixo de 1024px (redesenho mobile
 * do legado, 2026-09-24). Mesma informação das 7 colunas da tabela, no card
 * compacto de 3 linhas da ListaCompacta:
 *
 *   cliente                         [etapa]
 *   ambiente
 *   1234 · URGENTE · etapa 5d · atrasado 3d   (ERP só quando a origem é o backend)
 *
 * O toque abre o mesmo SlideOverPanel que o clique na linha da tabela.
 * Sem animação por card (listas de 400 itens).
 */
import React from "react";

import {
  CardItem,
  CardList,
  CardMeta,
  CardSub,
  CardTitulo,
  CardTopo,
} from "../../components/ListaCompacta/styles";

import { ETAPA_LABEL, ETAPA_TONE, PRIORIDADE_TONE } from "./classificador";
import { atrasoTone, fmtAtraso, fmtDias } from "./helpers";
import { MetaTom, Pill } from "./styles";

function tomDaBarra(item) {
  if (item.atrasoDias !== null && item.atrasoDias > 0) return "danger";
  return "default";
}

function CardAcompanhamento({ item, onAbrir }) {
  const abrir = () => onAbrir(item);
  const temPrioridade = item.prioridade && item.prioridade !== "NORMAL";
  return (
    <CardItem
      $barra={tomDaBarra(item)}
      $clicavel
      role="button"
      tabIndex={0}
      onClick={abrir}
      onKeyDown={(event) => {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          abrir();
        }
      }}
    >
      <CardTopo>
        <CardTitulo title={item.cliente}>{item.cliente}</CardTitulo>
        <span className="selo">
          <Pill $tone={ETAPA_TONE[item.etapa]}>{ETAPA_LABEL[item.etapa]}</Pill>
        </span>
      </CardTopo>
      <CardSub title={item.ambiente}>{item.ambiente}</CardSub>
      <CardMeta>
        <span className="par">
          <b>{item.numeroProjeto}</b>
        </span>
        {temPrioridade && (
          <span className="par">
            <span className="sep" aria-hidden="true">· </span>
            <MetaTom $tone={PRIORIDADE_TONE[item.prioridade] || "neutral"}>{item.prioridade}</MetaTom>
          </span>
        )}
        {item.origem === "backend" && (
          <span className="par">
            <span className="sep" aria-hidden="true">· </span>
            <span className="k">ERP</span>
          </span>
        )}
        <span className="par">
          <span className="sep" aria-hidden="true">· </span>
          <span className="k">etapa</span>{" "}
          <b>{item.diasNaEtapa != null ? `${item.diasNaEtapa}d` : fmtDias(item.diasNaEtapa)}</b>
        </span>
        {item.atrasoDias !== null && (
          <span className="par">
            <span className="sep" aria-hidden="true">· </span>
            <MetaTom $tone={atrasoTone(item.atrasoDias)}>{fmtAtraso(item.atrasoDias)}</MetaTom>
          </span>
        )}
      </CardMeta>
    </CardItem>
  );
}

export default function ListaCards({ itens, onAbrir }) {
  return (
    <CardList data-testid="acompanhamento-cards">
      {itens.map((it) => (
        <CardAcompanhamento key={it.id} item={it} onAbrir={onAbrir} />
      ))}
    </CardList>
  );
}
